<template>
  <ItemDialog ref="DialogDenyPurchaseWarning" imageType="alert">
    <template v-slot:content-area>
      <h2>
        購入エラー
      </h2>
      <p class="text-left">
        <br />
        決済の手続き開始から一定時間が経過しました。
        <br />
        トップページから購入結果をご確認ください。
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="トップページに戻る"
        actionType="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogDenyPurchaseWarning",
  props: {
    closeClick: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const DialogDenyPurchaseWarning = ref(null);

    const openDialog = () => {
      DialogDenyPurchaseWarning.value.open();
    };

    const closeDialog = () => {
      if(props.closeClick)
      {
        props.closeClick();
      }
      DialogDenyPurchaseWarning.value.close();
    };

    return {
      DialogDenyPurchaseWarning,
      openDialog,
      closeDialog,
    };
  },
};
</script>

<style scoped lang="scss">
.text-left {
  text-align: justify;
}
</style>

